import { Icon20ChevronUpOutline } from '@vkontakte/icons';
import { Button as IconWrapper, Text } from '@vkontakte/vkui';
import classNames from 'clsx';
import React, { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { emitAnalyticEvent } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import {
    SHARING_ONBOARDING_TOOLTIP_ID,
    SharingOnboardingTooltip,
} from 'reactApp/components/SharingWindow/blocks/SharingOnboarding/components/tooltips/SharingOnboardingTooltip';
import { PaidInfoSelectors } from 'reactApp/modules/paidInfo/paidInfo.selectors';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { SharedModalActions } from 'reactApp/modules/sharedModal/sharedModal.module';
import { UserStorageSelectors } from 'reactApp/modules/user/userStorage';
import type { RootState } from 'reactApp/store';
import { Button } from 'reactApp/ui/Button/Button';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

import styles from './SharingOnboardingHeader.css';

interface SharingOnboardingHeader {
    opened: boolean;
    toggleOpened: () => void;
}

export function SharingOnboardingHeader({ opened, toggleOpened }: SharingOnboardingHeader) {
    const ref = useRef<HTMLDivElement | null>(null);
    const tooltipOnboardingShown = Boolean(useSelector((state) => UserStorageSelectors.get(state, SHARING_ONBOARDING_TOOLTIP_ID)));
    const dispatch = useDispatch();
    const storage = useSelector(getCurrentStorage);
    const buyCallback = useCallback(() => {
        emitAnalyticEvent(AnalyticEventNames.ONBOARDING_TRIAL_BUTTON_CLICK);
        sendPaymentGa({
            action: 'click',
            eventCategory: ECategoryGa.button,
            name: 'mnz_advanced_settings_button',
            place: storage,
        });
        dispatch(SharedModalActions.buyOnboardingSubscription());
    }, [dispatch]);

    useEffect(() => {
        emitAnalyticEvent(AnalyticEventNames.ONBOARDING_TRIAL_BUTTON_SHOW);
        sendPaymentGa({
            action: 'show',
            eventCategory: ECategoryGa.button,
            name: 'mnz_advanced_settings_button',
            place: storage,
        });
    }, []);
    const buttonStringDefault = 'Подключить';
    const buttonStringTrial = '  Попробовать за 0 ₽';
    const userWithoutPayment = useSelector(PaidInfoSelectors.isUserWithoutPayment);
    const paidLessThan3Month = useSelector((state: RootState) => PaidInfoSelectors.lastPaymentWasLessThan(state, { months: 3 }));
    const buttonString = userWithoutPayment ? buttonStringTrial : paidLessThan3Month ? buttonStringDefault : buttonStringTrial;
    return (
        <div className={classNames(styles.root, { [styles.opened]: opened })}>
            <div className={styles.container}>
                <Text className={styles.text}>С подпиской Mail Space</Text>
                <IconWrapper data-qa-id="collapse" mode="link" appearance="neutral" size="m" onClick={toggleOpened}>
                    <Icon20ChevronUpOutline className={styles.icon} />
                </IconWrapper>
            </div>
            <div ref={ref}>
                <Button className={styles.button} onClick={buyCallback} qaId="buy">
                    {buttonString}
                </Button>
            </div>
            <SharingOnboardingTooltip target={ref} forcePromo={!tooltipOnboardingShown} />
        </div>
    );
}
